import { useState } from 'react';
import { Grid, Box, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

import { usePersistentFilterSelection } from 'store/filter';

import DishDisplay from '@components/DishDisplay';
import useEffectExcludingMount from '@utils/useEffectExcludingMount';
import { productType } from '@utils/types';
import {
  isArrTwoIncludeAnyElementOfArrOne,
  isArrTwoIncludeArrOne,
} from '@utils/helpers';
import theme from 'src/style-system/theme';

const useStyles = makeStyles({
  dishWrapper: {
    display: 'grid',
    columnGap: '32px',
    rowGap: '45px',
    gridTemplateColumns: 'repeat(auto-fill, 130px)',

    [theme.breakpoints.up('sm')]: {
      gridTemplateColumns: 'repeat(auto-fill, 200px)',
    },

    [theme.breakpoints.up('lg')]: {
      gridTemplateColumns: 'repeat(auto-fill, 220px)',
    },
  },
});
interface TabPanelContentProps {
  categoryName: string;
  products: productType[];
  isNoAddMealBtn?: boolean;
  categoryDescription?: string;
  isSubscriptionBtn?: boolean;
  mode?: string;
  isPantry?: boolean;
  elevarAddToCartEvent?: any;
  elevarRemoveFromCartEvent?: any;
  elevarViewItemEvent?: any;
}

const TabPanelContent = ({
  categoryName,
  products,
  isNoAddMealBtn = false,
  categoryDescription,
  isSubscriptionBtn = false,
  mode,
  isPantry = false,
  elevarAddToCartEvent,
  elevarRemoveFromCartEvent,
  elevarViewItemEvent,
}: TabPanelContentProps) => {
  const [dietaryFilterArr, setDietaryFilterArr] = useState<number[]>([]);
  const [placeFilterArr, setPlaceFilterArr] = useState<number[]>([]);
  const [spiceFilterArr, setSpiceFilterArr] = useState<number[]>([]);
  const [equipmentFilterArr, setEquipmentFilterArr] = useState<number[]>([]);

  const classes = useStyles();

  const filterSelect = usePersistentFilterSelection();

  useEffectExcludingMount(() => {
    const filterSelectKeyArray = Object.keys(filterSelect);
    let dietaryArr: number[] = [];
    let placeArr: number[] = [];
    let spiceArr: number[] = [];
    let equipmentArr: number[] = [];

    filterSelectKeyArray.forEach((key) => {
      if (filterSelect[key]?.isSelected) {
        if (filterSelect[key]?.filterGroupName === 'DIETARY_NEEDS') {
          dietaryArr.push(+key);
        } else if (filterSelect[key]?.filterGroupName === 'PLACE_OF_ORIGIN') {
          placeArr.push(+key);
        } else if (filterSelect[key]?.filterGroupName === 'SPICE_LEVEL') {
          spiceArr.push(+key);
        } else if (filterSelect[key]?.filterGroupName === 'EQUIPMENT') {
          equipmentArr.push(+key);
        }
      }
    });
    setDietaryFilterArr(dietaryArr);
    setSpiceFilterArr(spiceArr);
    setPlaceFilterArr(placeArr);
    setEquipmentFilterArr(equipmentArr);
  }, [filterSelect]);

  return (
    <>
      <Box sx={{ padding: { xs: '30px 0px 0px', sm: '30px 0px 0px' } }}>
        <Typography
          variant="h2"
          align="left"
          color="cinnamon.main"
          mb={categoryDescription ? '10px' : '20px'}
        >
          {categoryName[0].toUpperCase() + categoryName.slice(1)}
        </Typography>
        {categoryDescription && (
          <Typography variant="body2" align="left" color="cumin.main" mb="30px">
            {categoryDescription}
          </Typography>
        )}
        <Box className={classes.dishWrapper}>
          {products.map((product) => {
            if (
              dietaryFilterArr.length ||
              placeFilterArr.length ||
              spiceFilterArr.length ||
              equipmentFilterArr.length
            ) {
              let dietaryFiltevalidation: boolean = false;
              let otherFilterValidation: boolean = false;

              // for dietary filter
              if (dietaryFilterArr.length || equipmentFilterArr.length) {
                const compareTwoArray = isArrTwoIncludeArrOne(
                  dietaryFilterArr,
                  product?.filter_ids
                );

                const compareEquipmentTwoArray = isArrTwoIncludeArrOne(
                  equipmentFilterArr,
                  product?.filter_ids
                );

                dietaryFiltevalidation =
                  compareTwoArray && compareEquipmentTwoArray;
              } else {
                dietaryFiltevalidation = true;
              }

              // for other filter
              if (placeFilterArr.length || spiceFilterArr.length) {
                const isPlaceFilterIdContain =
                  isArrTwoIncludeAnyElementOfArrOne(
                    placeFilterArr,
                    product?.filter_ids
                  );
                const isSpiceFilterIdContain =
                  isArrTwoIncludeAnyElementOfArrOne(
                    spiceFilterArr,
                    product?.filter_ids
                  );

                otherFilterValidation =
                  isPlaceFilterIdContain && isSpiceFilterIdContain;
              } else {
                otherFilterValidation = true;
              }

              if (dietaryFiltevalidation && otherFilterValidation) {
                return (
                  <DishDisplay
                    key={product?.id}
                    product={product}
                    isModal
                    isNoAddMealBtn={isNoAddMealBtn}
                    isSubscriptionBtn={isSubscriptionBtn}
                    isMoreInfoBtn={true}
                    isShowRating={mode === 'edit'}
                    isPantry={isPantry}
                    mode={mode}
                    elevarAddToCartEvent={elevarAddToCartEvent}
                    elevarRemoveFromCartEvent={elevarRemoveFromCartEvent}
                    elevarViewItemEvent={elevarViewItemEvent}
                  />
                );
              }
            } else {
              return (
                <DishDisplay
                  key={product?.id}
                  product={product}
                  isModal
                  isNoAddMealBtn={isNoAddMealBtn}
                  isSubscriptionBtn={isSubscriptionBtn}
                  isMoreInfoBtn={true}
                  isShowRating={mode === 'edit'}
                  isPantry={isPantry}
                  mode={mode}
                  elevarAddToCartEvent={elevarAddToCartEvent}
                  elevarRemoveFromCartEvent={elevarRemoveFromCartEvent}
                  elevarViewItemEvent={elevarViewItemEvent}
                />
              );
            }
          })}
        </Box>
      </Box>
    </>
  );
};

export default TabPanelContent;
